import type { NLSDocument, Statement } from "./types.ts";
import { generateSIDs } from "./addressing.ts";

import engelbartData from "../../content/augmenting-human-intellect.json";
import bushData from "../../content/as-we-may-think.json";
import nlsGuideData from "../../content/nls-user-guide.json";

/** In-memory document store. */
const documents = new Map<string, NLSDocument>();

function loadDocument(data: unknown): NLSDocument {
  const doc = data as NLSDocument;
  // Ensure SIDs are consistent
  generateSIDs(doc.root);
  return doc;
}

// Load seed content
function initStore(): void {
  const docs = [engelbartData, bushData, nlsGuideData];
  for (const data of docs) {
    const doc = loadDocument(data);
    documents.set(doc.id, doc);
  }
}

initStore();

export function getDocument(id: string): NLSDocument | undefined {
  return documents.get(id);
}

export function listDocuments(): NLSDocument[] {
  return Array.from(documents.values());
}

export function updateDocument(id: string, root: Statement): void {
  const doc = documents.get(id);
  if (!doc) return;
  doc.root = root;
  doc.modified = new Date().toISOString();
  generateSIDs(doc.root);
}

export function getDocumentTitle(id: string): string {
  return documents.get(id)?.title ?? id;
}
